<template>
  <div class="container">
    <div class="veil"></div>
    <div class="box" :style="{ width: width }"><slot /></div>
  </div>
</template>
<script>
export default {
  name: "PopupDialog",
  props: ["width"],
  data: function() {
    return {
      visible: false
    };
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

.container {
  z-index: 10;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0;
  display: grid;
  align-items: center;
  padding: 10px;
  padding-bottom: 5%;
  justify-content: center;
}

.box {
  padding: 10px;
  background-color: white;
  z-index: 1000;
}

.veil {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0;
  background-color: black;
  opacity: 0.7;
}

@media screen and (max-width: 1024px) {
  .container {
    padding: 10px;
    padding-bottom: 10%;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
